import gsap from 'gsap';
import { CustomEase } from 'gsap/CustomEase';

gsap.registerPlugin(CustomEase);

export const ease = CustomEase.create('custom', '0.17, 0.17, 0, 1');
